export default __webpack_public_path__ + "static/step2-67339483e4bedfe547776c8a437c9062.jpeg";